const getters = {
  users: (state) => state.users,
  user: (state) => state.user,
  processing: (state) => state.processing,
  processingUser: (state) => state.processingUser,
};

export default getters;
